export { VendorResolverContext, VendorResolverProvider } from '../_internal/context/VendorResolverContext';